var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { ref: "slideContainer", staticClass: "cash" },
    [
      _c("Title", {
        attrs: { zhTitle: "现金获取能力", enTitle: "Cash Creation Ability" },
      }),
      _c("div", { staticClass: "cards" }, [
        _vm.jyxxjl
          ? _c("div", { staticClass: "card" }, [
              _vm.language === "zh"
                ? _c("div", { staticClass: "zh" }, [
                    _c("div", { staticClass: "card-title" }, [
                      _vm._v(
                        _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName) + " "
                      ),
                      _c("span", { staticClass: "card-text" }, [
                        _vm._v("经营性现金流"),
                      ]),
                    ]),
                    _c("div", { staticClass: "num" }, [
                      _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.jyxxjl)),
                      _c("span", { staticClass: "unit" }, [
                        _vm._v(_vm._s(_vm.jyxxjlUnit)),
                      ]),
                    ]),
                  ])
                : _vm.language === "en"
                ? _c("div", { staticClass: "en" }, [
                    _c("div", { staticClass: "card-title" }, [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.jsonData.year) +
                          _vm._s(_vm.periodNameEng) +
                          "\n\t\t\t\t\t"
                      ),
                      _c("div", { staticClass: "card-text" }, [
                        _vm._v("Operating Cash Flow"),
                      ]),
                    ]),
                    _c("div", { staticClass: "num" }, [
                      _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.jyxxjl)),
                      _c("span", { staticClass: "unit" }, [
                        _vm._v(_vm._s(_vm.jyxxjlUnit)),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _c("div", { ref: "chart1", staticClass: "charts" }),
            ])
          : _vm._e(),
        _vm.tzxxjl
          ? _c("div", { staticClass: "card" }, [
              _vm.language === "zh"
                ? _c("div", { staticClass: "zh" }, [
                    _c("div", { staticClass: "card-title" }, [
                      _vm._v(
                        _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName) + " "
                      ),
                      _c("span", { staticClass: "card-text" }, [
                        _vm._v("投资性现金流"),
                      ]),
                    ]),
                    _c("div", { staticClass: "num" }, [
                      _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.tzxxjl)),
                      _c("span", { staticClass: "unit" }, [
                        _vm._v(_vm._s(_vm.tzxxjlUnit)),
                      ]),
                    ]),
                  ])
                : _vm.language === "en"
                ? _c("div", { staticClass: "en" }, [
                    _c("div", { staticClass: "card-title" }, [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.jsonData.year) +
                          _vm._s(_vm.periodNameEng) +
                          "\n\t\t\t\t\t"
                      ),
                      _c("div", { staticClass: "card-text" }, [
                        _vm._v("Investment Cash Flow"),
                      ]),
                    ]),
                    _c("div", { staticClass: "num" }, [
                      _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.tzxxjl)),
                      _c("span", { staticClass: "unit" }, [
                        _vm._v(_vm._s(_vm.tzxxjlUnit)),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _c("div", { ref: "chart2", staticClass: "charts" }),
            ])
          : _vm._e(),
        _vm.czxxjl
          ? _c("div", { staticClass: "card" }, [
              _vm.language === "zh"
                ? _c("div", { staticClass: "zh" }, [
                    _c("div", { staticClass: "card-title" }, [
                      _vm._v(
                        _vm._s(_vm.jsonData.year) + _vm._s(_vm.periodName) + " "
                      ),
                      _c("span", { staticClass: "card-text" }, [
                        _vm._v("筹资性现金流"),
                      ]),
                    ]),
                    _c("div", { staticClass: "num" }, [
                      _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.czxxjl)),
                      _c("span", { staticClass: "unit" }, [
                        _vm._v(_vm._s(_vm.czxxjlUnit)),
                      ]),
                    ]),
                  ])
                : _vm.language === "en"
                ? _c("div", { staticClass: "en" }, [
                    _c("div", { staticClass: "card-title" }, [
                      _vm._v(
                        "\n\t\t\t\t\t" +
                          _vm._s(_vm.jsonData.year) +
                          _vm._s(_vm.periodNameEng) +
                          "\n\t\t\t\t\t"
                      ),
                      _c("div", { staticClass: "card-text" }, [
                        _vm._v("Financing Cash Flow"),
                      ]),
                    ]),
                    _c("div", { staticClass: "num" }, [
                      _vm._v("\n\t\t\t\t\t" + _vm._s(_vm.czxxjl)),
                      _c("span", { staticClass: "unit" }, [
                        _vm._v(_vm._s(_vm.czxxjlUnit)),
                      ]),
                    ]),
                  ])
                : _vm._e(),
              _c("div", { ref: "chart3", staticClass: "charts" }),
            ])
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }